import styled, { css } from 'styled-components'
import { Text } from '../../../../atoms/text'
import { themeMedia } from '../../../../../styles/theme'

export const StyledTermsAndConditionsWrapper = styled.div`
  position: relative;
  min-height: calc(100dvh - 65px);

  ${(props) => !props.isPage && themeMedia.tablet`
    min-height: calc(100dvh - 120px);
    min-height: auto;
  `}
`

export const TermsAndConditionsMaxHeightCss = css`
  ${themeMedia.tablet`
   max-height:  calc(100dvh - 446px);
  `}

  ${themeMedia.navbarBreakpointTabletDesktop`
    max-height:  calc(100dvh - 600px);
  `}
`

export const StyledTermsAndConditions = styled.div`
  overflow: auto;
  margin-top: 40px;
  margin-bottom: 20px;
  max-height:  calc(100dvh - 285px);

  ${themeMedia.tablet`
    max-height:  calc(100dvh - 334px);
  `}

 ${(props) => !props.isPage && TermsAndConditionsMaxHeightCss};
`

export const StyledTermsAndConditionsTitle = styled(Text)`
  font-weight: bold;
  font-size: 20px;
`

export const StyledTermsAndConditionsDescription = styled(Text)`
  margin-bottom: 30px;
`

export const StyledBottomDiv = styled.div`
  ${themeMedia.maxTablet`
    position: absolute;
    bottom: 30px;
    left: 0;
    right: 0;
  `}
`